import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ContentSection } from './components/ContentSection';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { CtaFinalSection } from './components/CtaFinalSection';
import { ProtocoloEliteSection } from './components/ProtocoloEliteSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { ParticlesBackground } from './components/ParticlesBackground';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="min-h-screen bg-spaceBg text-white font-sans scroll-smooth relative" data-id="element-0">
      {/* Global Space/Galaxy Background */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden bg-spaceBg" data-id="element-1" />

      {/* Meta Pixel tracking image */}
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1934048370513297&ev=PageView&noscript=1" alt="" data-id="element-2" />

      <div className="relative z-10" data-id="element-3">
        <main data-id="element-4">
          <HeroSection data-id="element-5" />
          <ProblemSection data-id="element-6" />
          <ContentSection data-id="element-7" />
          <BonusSection data-id="element-8" />
          <UrgencySection data-id="element-9" />
          <CtaFinalSection data-id="element-10" />
          <ProtocoloEliteSection data-id="element-11" />
          <TestimonialsSection data-id="element-12" />
          <GuaranteeSection data-id="element-13" />
          <FaqSection data-id="element-14" />
          <ClosingSection data-id="element-15" />
        </main>

        <Footer data-id="element-16" />
      </div>

      {/* Social proof purchase notifications */}
      <PurchaseNotifications data-id="element-17" />
    </div>;
}